import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { SlidersHorizontal, Plus } from "lucide-react";
import { api } from "../lib/api";
import { GigCard } from "../components/Cards";
import { Pagination } from "../components/Pagination";
import { STATES, PERFORMANCE_TYPES, GENRES } from "../lib/constants";

export default function Gigs() {
  const [sp] = useSearchParams();
  const [items, setItems] = useState([]);
  const [meta, setMeta] = useState({ total: 0, pages: 1 });
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ q: sp.get("q") || "", state: "", city: "", performance_type_needed: "", genre_needed: "" });

  const load = async () => {
    setLoading(true);
    const p = new URLSearchParams({ open_only: "true", page, limit: 12 });
    Object.entries(f).forEach(([k, v]) => { if (v) p.set(k, v); });
    const { data } = await api.get(`/gigs?${p.toString()}`);
    setItems(data.items); setMeta(data); setLoading(false);
  };
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [f, page]);
  const set = (k, v) => { setF((s) => ({ ...s, [k]: v })); setPage(1); };
  const sel = "w-full bg-[#0a0a0a] border border-white/10 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-rose-500";

  return (
    <div className="px-6 md:px-12 lg:px-20 py-10" data-testid="gigs-page">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
        <div>
          <p className="overline mb-2">The Gulf Coast gig marketplace</p>
          <h1 className="font-display font-extrabold text-4xl md:text-5xl">Open Gigs</h1>
          <p className="text-zinc-400 mt-2">Venues & promoters post opportunities. Artists bid to play.</p>
        </div>
        <Link to="/submit-gig" className="bg-rose-500 hover:bg-rose-600 font-bold px-6 py-3 rounded-full flex items-center gap-2 w-fit" data-testid="post-gig-btn"><Plus size={18} /> Post a Gig</Link>
      </div>
      <div className="grid lg:grid-cols-12 gap-8">
        <aside className="lg:col-span-3">
          <div className="lg:sticky lg:top-20 bg-[#111] border border-white/10 rounded-xl p-5 space-y-4">
            <div className="flex items-center gap-2 font-semibold"><SlidersHorizontal size={16} /> Filters</div>
            <input value={f.q} onChange={(e) => set("q", e.target.value)} placeholder="Search gigs" className={sel} data-testid="gfilter-q" />
            <select value={f.state} onChange={(e) => set("state", e.target.value)} className={sel} data-testid="gfilter-state"><option value="">All States</option>{STATES.map((s) => <option key={s} value={s}>{s}</option>)}</select>
            <input value={f.city} onChange={(e) => set("city", e.target.value)} placeholder="City" className={sel} data-testid="gfilter-city" />
            <select value={f.performance_type_needed} onChange={(e) => set("performance_type_needed", e.target.value)} className={sel} data-testid="gfilter-ptype"><option value="">Any performance type</option>{PERFORMANCE_TYPES.map((s) => <option key={s} value={s}>{s}</option>)}</select>
            <select value={f.genre_needed} onChange={(e) => set("genre_needed", e.target.value)} className={sel} data-testid="gfilter-genre"><option value="">Any genre</option>{GENRES.map((s) => <option key={s} value={s}>{s}</option>)}</select>
          </div>
        </aside>
        <div className="lg:col-span-9">
          <p className="text-sm text-zinc-400 mb-5">{loading ? "Loading..." : `${meta.total} open gigs`}</p>
          <div className="grid sm:grid-cols-2 gap-5">{items.map((g) => <GigCard key={g.id} g={g} />)}</div>
          {!loading && items.length === 0 && <p className="text-zinc-500 py-20 text-center">No open gigs match your filters.</p>}
          <Pagination page={page} pages={meta.pages} onPage={setPage} />
        </div>
      </div>
    </div>
  );
}
